<template>
  <div class="calendar">
    <v-calendar
      ref="calendar"
      :first-day-of-week="1"
      is-dark="true"
      borderless
      transparent
      title-position="left"
      :expanded="true"
      :locale="calendarLocale"
      :attributes="calendarAttributes"
      :month="1"
      :year="2000"
      transition="none"
      @dayclick="onClickDay"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { Calendar as vCalendar } from 'v-calendar'
import 'v-calendar/style.css'

import TranslateService from '@/services/TranslateService'

export default {
  components: {
    vCalendar
  },
  props: [
    'selected'
  ],
  data () {
    return {
      calendarLocale: 'en-US',
      calendarLocaleMap: {
        en: 'en-US',
        tc: 'zh-TW',
        sc: 'zh-CN'
      },
      calendarAttributes: null
    }
  },
  async mounted () {
    this.calendarLocale = this.calendarLocaleMap[TranslateService.currentLocale]
    this.updateCalendarAttributes()
    this.$refs.calendar.month = 1
    this.$refs.calendar.year = 2000
    this.$refs.calendar.move(new Date(this.selected.date), { transition: 'none' })
  },
  methods: {
    updateCalendarAttributes () {
      this.calendarAttributes = [
        {
          key: 'today',
          highlight: '#2A65FD',
          dates: new Date()
        }
      ]
      if (!this.selected.isSearch) {
        this.calendarAttributes.push(
          {
            key: 'selectedDate',
            highlight: 'blue',
            dates: new Date(this.selected.date),
            order: 1
          }
        )
      }
    },
    onClickDay (dayInfo) {
      const newDate = moment(dayInfo.date).format('YYYY-MM-DD')
      _.set(this.selected, 'date', newDate)
      this.$emit('update:selected', this.selected)
      this.$emit('change', this.selected)
    }
  }
}
</script>

<style lang="scss" scoped>

.calendar {
  color: white;
  background-color: #2A65FD;
  width: 363px;
  padding: 35px 32px;
  // h1 {
  //   font-family: Poppins-Bold;
  //   font-size: 20px;
  //   margin-bottom: 21px;
  //   padding-bottom: 12px;
  //   border-bottom: 1px white solid;
  //   display: flex;
  //   justify-content: space-between;

  //   .arrow {
  //     border: solid white;
  //     border-width: 0 2px 2px 0;
  //     display: inline-block;
  //     padding: 4.5px;
  //   }
  //   .arrow-left {
  //     transform: rotate(135deg);
  //     -webkit-transform: rotate(135deg);
  //     margin-right: 22px;
  //   }
  //   .arrow-right {
  //     transform: rotate(-45deg);
  //     -webkit-transform: rotate(-45deg);
  //     margin-right: 2px;
  //   }
  // }
}

</style>
